module.exports = __webpack_public_path__ + "static/media/live-casino-games-en.69a157c0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/slider-banners/jacktop-games/live-casino-games-en.png
// module id = 905
// module chunks = 7